<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="config?.Label">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ config.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="levelType && levelType >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationgroundlevel.ground-level' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ levelType | leveltype }}</span>
      </p>
    </td>
  </tr>
</table>
